import React from 'react'
import ThemedList from 'components/atoms/ThemedList'
import { listArrow } from 'styles/list'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import ListItem from 'components/atoms/ListItem'

const HomeMoreTravelHistoryProfilesScene = () => {
	
	const navigation = useNavigation();
	
	const openDetails = ( item= {} ) => {
		navigation.navigate( AppRoutes.MORE_TRAVEL_HISTORY_PROFILE_EDIT );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openDetails }
			/>
		)
	}
	
	let list = [
		{
			name: 'Profiel 1'
		}
	];
	
	
	return (
		<ThemedBlock shadow>
			<ThemedList
				data={ list }
				dividerEnabled={ true }
				renderItem={ renderItem.bind( this ) }
			/>
		</ThemedBlock>
	)
}

export default HomeMoreTravelHistoryProfilesScene
